<div class="el" fxLayout="column" fxLayoutWrap="nowrap" fxFlex="100">
  <div class="section-behind">
    <span class="title">{{title}}</span>
  </div>
  <div class="section-title">
    <h1 class="title" *ngIf="h1">{{subtitle}}</h1>
    <span class="title" *ngIf="!h1">{{subtitle}}</span>
  </div>
</div>